import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faListCheck } from '@fortawesome/free-solid-svg-icons';
import { MultiSelect } from '@progress/kendo-react-dropdowns';
import type { FieldTypeDefinition, FieldRendererProps } from '../registry';
import { OptionsEditor } from '../shared/OptionsEditor';

function MultiSelectRenderer({ field, value, onChange, readOnly }: FieldRendererProps) {
  const options = field.options ?? [];
  const selectedValues = Array.isArray(value) ? value : [];
  const selected = options.filter((o) => selectedValues.includes(o.value));
  return (
    <MultiSelect
      data={options}
      textField="label"
      dataItemKey="id"
      value={selected}
      onChange={(e) => onChange((e.value ?? []).map((o: { value: string }) => o.value))}
      disabled={readOnly}
    />
  );
}

export const definition: FieldTypeDefinition = {
  key: 'MSL',
  label: 'Multi-Select',
  category: 'choice',
  icon: <FontAwesomeIcon icon={faListCheck} fixedWidth />,
  defaultProps: {
    label: 'New multi-select',
    isRequired: false,
    options: [
      { id: 'o1', value: 'option-1', label: 'Option 1', order: 0 },
      { id: 'o2', value: 'option-2', label: 'Option 2', order: 1 },
    ],
  },
  Renderer: MultiSelectRenderer,
  PropertyEditor: OptionsEditor,
};
